export const imagesFileTypes = [
  'image/bmp',
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/svg+xml',
  'image/tiff',
  'image/heif',
  'image/heic',
];

export const supportedFileTypes = [
  ...imagesFileTypes,
  'application/pdf',
  'application/msword',
  'application/rtf',
  'application/tif',
  'application/tiff',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/x-zip-compressed',
  'application/zip',
  'audio/wav',
  'text/csv',
  'text/html',
  'text/plain',
];

export const defaultFileSizeMBLimit = 100;

const defaultConfig = { imagesOnly: false, allowPdf: true };

/**
 * Returns supported file types list as an array of strings
 *
 *  @property {Boolean?} imagesOnly If true returns images types only (false by default)
 *  @property {Boolean?} allowPdf If false PDF is excluded for images only list (true by default)
 *  @returns {Array<string> | null} Supported file types list
 * */
export const buildFileTypesList = (config = defaultConfig) => {
  const { imagesOnly, allowPdf } = { ...defaultConfig, ...config };

  // All supported types
  if (!imagesOnly) {
    return ['', ...supportedFileTypes];
  }

  // Images only
  if (allowPdf) { // Usually PDF is allowed for images upload
    return ['', ...imagesFileTypes, 'application/pdf'];
  }

  return ['', ...imagesFileTypes];
};
